import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { AuthShell } from "@/pages/Login";

export default function ResetPassword() {
    const [params] = useSearchParams();
    const token = params.get("token");
    const navigate = useNavigate();
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await api.post("/auth/reset-password", { token, password });
            toast.success("Password reset! Please log in.");
            navigate("/login");
        } catch (err) {
            toast.error(apiError(err));
        } finally {
            setLoading(false);
        }
    };

    if (!token) return <AuthShell title="Reset Password"><p className="text-center text-muted-foreground">Invalid reset link. <Link to="/forgot-password" className="text-gold hover:underline">Request a new one</Link>.</p></AuthShell>;

    return (
        <AuthShell title="Set New Password">
            <form onSubmit={submit} className="space-y-4">
                <input data-testid="reset-password" type="password" required placeholder="New password (min 6 characters)" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full bg-white border border-[#E8DFD5] px-4 py-3 text-sm outline-none focus:border-gold" />
                <button data-testid="reset-submit" disabled={loading} className="w-full bg-ink text-cream py-3 text-sm uppercase tracking-[0.15em] hover:bg-gold transition-colors disabled:opacity-50">{loading ? "Resetting…" : "Reset Password"}</button>
            </form>
        </AuthShell>
    );
}
